import type { PriceItemType } from 'core/accounting/domain/PriceItemType'

export type Accessorial = {
  type: number
  label: string
  name: string
  shipperNotes: string
}

export type PriceItemTypeWithNotes = PriceItemType & {
  shipperNotes: string
}

export type AccessorialRate = {
  id?: number
  notes: string
  rate: string
  lastRate?: string
  type?: number
  priceItemType?: PriceItemType
}

export const enum SubmitAccessorialRateAction {
  Create = 'create',
  Update = 'update',
  Delete = 'delete',
}

export const initialAccessorialRate: AccessorialRate = {
  id: undefined,
  rate: '',
  notes: '',
  type: -1,
  priceItemType: undefined,
}

export function shouldCreateAccessorialRate(accessorialRate: AccessorialRate) {
  const hasAccessorialRateId = Boolean(accessorialRate.id)
  const validRate = Number(accessorialRate.rate) > 0
  const hasNotes = accessorialRate.notes.length > 0
  return !hasAccessorialRateId && (validRate || hasNotes)
}

export function shouldUpdateAccessorialRate(accessorialRate: AccessorialRate) {
  const hasAccessorialRateId = Boolean(accessorialRate.id)
  const validRate = Number(accessorialRate.rate) > 0
  const hasNotes = accessorialRate.notes.length > 0
  return hasAccessorialRateId && (validRate || hasNotes)
}

export function shouldDeleteAccessorialRate(accessorialRate: AccessorialRate) {
  const hasAccessorialRateId = Boolean(accessorialRate.id)
  const areBothFieldsEmpty =
    Number(accessorialRate.rate) === 0 && accessorialRate.notes.length === 0
  return hasAccessorialRateId && areBothFieldsEmpty
}

export function getSubmitAction(accessorialRate: AccessorialRate) {
  if (shouldCreateAccessorialRate(accessorialRate)) {
    return SubmitAccessorialRateAction.Create
  }

  if (shouldUpdateAccessorialRate(accessorialRate)) {
    return SubmitAccessorialRateAction.Update
  }

  if (shouldDeleteAccessorialRate(accessorialRate)) {
    return SubmitAccessorialRateAction.Delete
  }
}
